export default __webpack_public_path__ + "static/storquest-logo-98f231206b7c9dd2aa6f6389fb78f647.png";